module.exports = __webpack_public_path__ + "static/media/instructivo4.ee07194d.png";